import axios from "axios";
import authHeader from "../../Services/auth-header";
import { refreshToken } from "../../Services/auth.service";
import { baseURGetProject } from "../../Services/client";

export function createGetProjectDetail({
  projectId,
  navigate,
  pageLanguage,
  catID,
  modelID,
  setProjectDetails,
}) {
  return function getProjectDetail(basketId) {
    axios
      .get(baseURGetProject, {
        params: {
          id: basketId ? basketId : projectId,
        },
        headers: authHeader(),
      })
      .then((response) => {
        setProjectDetails(response.data, basketId);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getProjectDetail();
            } else {
              navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
            }
          });
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      });
  };
}
